import { render } from "./Kinmen.vue?vue&type=template&id=a8498758"
import script from "./Kinmen.vue?vue&type=script&lang=js"
export * from "./Kinmen.vue?vue&type=script&lang=js"

import "./Kinmen.vue?vue&type=style&index=0&id=a8498758&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__